import React, { useEffect } from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import { useTierGating } from '../../hooks/useTierGating';
import { useUpsellTracking } from '../../hooks/useUpsellTracking';
import FeatureIframe from '../../components/organisms/featureIframe';
import TalentCommunitiesImage from '../../assets/feature-intro-talent-communities.png';
import TalentCommunitiesTestimonialAvatar from '../../assets/feature-intro-talent-communities-testimonial-avatar.png';

export const TalentCommunities = () => {
  usePageTitle('Talent Communities');
  const { hasCapability } = useTierGating();
  const { trackPaywallShown } = useUpsellTracking();
  const hasAccess = hasCapability('talent_communities');

  useEffect(() => {
    if (!hasAccess) {
      trackPaywallShown('talent_communities');
    }
  }, [hasAccess, trackPaywallShown]);

  if (!hasAccess) {
    return (
      <MainLayout containerProps={{ pb: 0, minHeight: '100vh' }}>
        <MainLayoutHeader title="Talent Communities" />
        <FeatureIntro
          featureName="Talent Communities"
          title="Build and nurture your talent communities"
          description="Sync custom forms with audiences to send regular community updates, event invites, and value-add content to your network."
          features={[
            'Create unlimited forms with unique fields to personalize engagement',
            'Stay top of mind for portfolio employees and future founders',
            'Grow your talent network and deepen engagement with your brand',
          ]}
          image={TalentCommunitiesImage}
          imageAlt="Talent Communities feature preview"
          ctaText="Get Talent Communities today"
          footerNote="Build communities that drive talent engagement"
          testimonial={{
            avatarSrc: TalentCommunitiesTestimonialAvatar,
            quote:
              'Campaigns help maintain momentum while supporting real conversations, directly leading to interviews and hires.',
            author: 'Carrie Whetzel',
            role: 'Talent Acquisition Manager, Tindall Corporation',
          }}
        />
      </MainLayout>
    );
  }

  return <FeatureIframe featureKey="talentCommunities" title="Findem Talent Communities" />;
};
